export const returnDateAndIsoWeekDayFromReportDayValue = (dayValue) => {
  const splitDateAndIsoWeekDay = dayValue.split('_');

  const date = splitDateAndIsoWeekDay[0];
  const isoWeekDay = splitDateAndIsoWeekDay[1];

  return { date, isoWeekDay };
};
